import { createCustomInterceptorInstance } from '@fundacao/shared-components/esm/ie/renovacao';
import axios, { AxiosInstance } from 'axios';

class FinancialDataService {
  private http: AxiosInstance;

  constructor() {
    this.http = createCustomInterceptorInstance(process.env.REACT_APP_USER_SESSION_API);
   
  }

  async getData(): Promise<any> {
    const resp = await this.http
      .get(`/usuarios-ies/dados-financeiros`)
      .catch((err) => Promise.reject(err.response));
    return resp.data;
  }
  
  async saveAccount(formData): Promise<any> {

    const body = {
      id: formData.id,
      banco: formData.banco,
      agencia: formData.agencia,
      conta: formData.conta,
      telefone: formData.telefone,
      email: formData.email,
      nomeResponsavel: formData.nomeResponsavel,
      isCampus: !!formData.codCampus,
    };

    const resp = await this.http
      .patch(`/usuarios-ies/dados-financeiros`, body)
      .catch((err) => Promise.reject(err.response));
    return resp.data;
  }
}

export default new FinancialDataService();